var map = {
	"./arch/arch-inf-sel.svg": 64629,
	"./arch/arch-sup-sel.svg": 67476,
	"./arch/base-arch-sel.svg": 76727,
	"./bar/bar-sel.svg": 52261,
	"./bracket/bracket-sel.svg": 99189,
	"./custom-pin/custom-pin-sel.svg": 16813,
	"./gig/gig-sel.svg": 11197,
	"./gum/gum-sel.svg": 33317,
	"./milling/milling-sel.svg": 27021,
	"./stump/stump-sel.svg": 17437
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49882;